import styled from 'styled-components';

export const Wrap = styled.div`
  && {
    .section {
      height: 140px;
      background-color: #ecffb8;
      .choose-time {
        padding: 15px 40px;
        display: flex;
        align-items: center;
      }
      .btn-change {
        border-radius: 5px;
        background-color: #ff8a00;
        color: white;
        border: none;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
      }
      .btn-money-output {
        width: 171px;
        height: 35px;
        background-color: #a956ea;
        color: white;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border: none;
        border-radius: 5px;
        margin-left: 22px;
      }
    }
    .mgt-13 {
      margin-top: 13px;
    }
    .mgrl-25 {
      margin: 0px 25px;
    }
    .w-card {
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }
    .w-card-direct {
      width: 323px;
    }
    w-card-debt {
      width: 194px;
    }
    .w-bg-ec {
      background-color: #c1e18d;
    }
    .w-bg-gr {
      background-color: #f7f7f7;
    }
    .money-info {
      padding: 24px;
      background-color: white;
      text-align: center;
      font-family: Hiragino Kaku Gothic Pro;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
    }
    .dl {
      display: flex;
      margin-top: 42px;
    }
    .ant-col-4 {
      max-width: 14.6%;
    }
    .ant-col-3 {
      max-width: 10.5%;
    }
    .table {
      margin-top: 40px;
      margin-bottom: 40px;
      padding-right: 40px;
    }
    .ant-tabs {
      margin-left: 40px;
      margin-top: 7px;
    }
    .ant-tabs-tab {
      background-color: rgba(236, 255, 184, 1);
      width: 170px;
      height: 56px;
      border-top-left-radius: 15px !important;
      border-top-right-radius: 15px !important;
      margin-right: 10px;
      color: black;
      font-family: Hiragino Kaku Gothic Pro;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: black;
    }
    .ant-tabs-card.ant-tabs-top > .ant-tabs-nav .ant-tabs-tab-active,
    .ant-tabs-card.ant-tabs-top > div > .ant-tabs-nav .ant-tabs-tab-active {
      background-color: white;
      transition: 1s;
    }
    .ant-tabs-top > .ant-tabs-nav::before,
    .ant-tabs-bottom > .ant-tabs-nav::before,
    .ant-tabs-top > div > .ant-tabs-nav::before,
    .ant-tabs-bottom > div > .ant-tabs-nav::before {
      border-bottom: none !important;
    }
    .ant-card-head {
      height: 30px !important;
      min-height: 0px;
      text-align: center;
      border-bottom: none;
    }
    .ant-card-head-title {
      padding: 10px 0px;
      font-family: Hiragino Kaku Gothic Pro;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
    }
    .ant-card-body {
      padding: 10px;
    }
    .ant-col-5 {
      max-width: 17.8%;
      margin-left: 10px;
    }
    .detail {
      padding: 18px 0px 18px 25px;
      display: flex;
      align-items: center;
      .label-input {
        display: flex;
        align-items: center;
        margin-right: 10px;
      }
      .btn-backSetup {
        height: 43px;
        background-color: #c4c4c4;
        color: white;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
        margin-left: 45px;
      }
      .btn-narrow-down-display {
        width: 172px;
        height: 43px;
        color: white;
        background-color: #ff8a00;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        border: none;
      }
    }
    .form-search {
      margin: 23px 45px 40px 0px;
      box-shadow: 1px 0px 10px rgba(0, 0, 0, 0.25);
      border-radius: 10px 10px 0px 0px;
    }
    .info-clinic {
      background-color: red;
    }
    .invoice-icon {
      color: black;
    }
    .invoice-icon:hover {
      color: orange;
    }
  }
`;
